import axios from './_nestAxios'

export const iniciarJob = (tipo, parametros) =>
  axios.post('/background-jobs/iniciar', { tipo, parametros })

export const iniciarLibroDiario = parametros =>
  iniciarJob('LIBRO_DIARIO', parametros)

export const iniciarLibroMayor = parametros =>
  iniciarJob('LIBRO_MAYOR', parametros)

export const iniciarReporteDiario = parametros =>
  iniciarJob('REPORTE_DIARIO', parametros)

export const iniciarReporteListaOperaciones = parametros =>
  iniciarJob('REPORTE_LISTA_OPERACIONES', parametros)

export const iniciarReporteLibroMayor = parametros =>
  iniciarJob('REPORTE_LIBRO_MAYOR', parametros)

export const iniciarReporteGastosPorCuenta = parametros =>
  iniciarJob('REPORTE_GASTOS_CUENTA', parametros)

export const iniciarReporteResumenMayor = parametros =>
  iniciarJob('REPORTE_RESUMEN_MAYOR', parametros)

export const iniciarMayorizacion = parametros =>
  iniciarJob('MAYORIZACION', parametros)

export const obtenerPendientes = () =>
  axios.get('/background-jobs/pendientes')

export const obtenerLista = () =>
  axios.get('/background-jobs/lista')

export const obtenerEstado = id =>
  axios.get(`/background-jobs/${id}/estado`)

export const descargarResultado = id =>
  axios.get(`/background-jobs/${id}/descargar`, { responseType: 'blob' })

export const marcarVisto = id =>
  axios.put(`/background-jobs/${id}/visto`)

export const marcarTodosVistos = () =>
  axios.put('/background-jobs/marcar-todos-vistos')
